
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import DeviceStatsTable from "@/modules/DeviceStats/components/DeviceStatsTable.vue";
  import AppSwitch from "@/components/AppSwitch.vue";
  import {cookieBannerHelper} from "@/shared/CookieBanner/helpers/cookie-banner-helper";

  @Component({
    components: {
      AppSwitch,
      DeviceStatsTable,
      AppDialog,
    },
  })
  export default class DeviceStatsPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'allPages', dialogName: 'deviceStatsPopup' };
    loading = true;
    filters = {
      detailFlag: false,
    };
    filtersStorageKey = 'deviceStatsFilters';

    async created() {
      if (cookieBannerHelper.cookieConfig.optional) {
        let storageValue = localStorage.getItem(this.filtersStorageKey);
        if (storageValue) {
          this.filters = {...JSON.parse(storageValue)};
        }
      }

      await this.loadData();
      this.loading = false;
    }

    async changeValue(value: any, name: string) {
      Vue.set(this.filters, name, value);
      localStorage.setItem(this.filtersStorageKey, JSON.stringify(this.filters));
      await this.loadData();
    }

    async loadData() {
      await this.$store.dispatch('deviceStats/getDeviceStats', { filters: this.filters });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
